import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MenuHeaderComponent } from '@ui';

@NgModule({
  declarations: [MenuHeaderComponent],
  imports: [TranslateModule, MatIconModule, CommonModule],
  exports: [MenuHeaderComponent],
})
export class XtenMenuHeaderModule {}
